import React, { useState } from 'react';

export default function ChangePassword({ user, onDone }) {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      const res = await fetch('/api/auth/change-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ new_password: newPassword, confirm_password: confirmPassword })
      });
      const data = await res.json();
      if (!res.ok) {
        setError(data.error || 'Failed to change password');
      } else {
        onDone();
      }
    } catch {
      setError('Connection error — please try again');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={{
      minHeight: '100vh',
      background: 'var(--color-bg)',
      display: 'flex',
      flexDirection: 'column'
    }}>
      <header className="header">
        <div className="header-product">Sports Import Tool</div>
      </header>

      <div style={{
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '40px 16px'
      }}>
        <div style={{ width: '100%', maxWidth: '380px' }}>
          <div className="card">
            <div className="card-header">
              <span className="card-label">Change password</span>
            </div>
            <div className="card-body">
              <p style={{ fontSize: '13px', color: 'var(--color-text-secondary)', marginBottom: '20px' }}>
                Welcome, {user?.full_name}. Please set a new password before continuing.
              </p>
              <form onSubmit={handleSubmit}>
                <div style={{ marginBottom: '16px' }}>
                  <label style={{
                    display: 'block', fontSize: '12px', fontWeight: 600,
                    color: 'var(--color-text-secondary)', marginBottom: '6px',
                    textTransform: 'uppercase', letterSpacing: '0.05em'
                  }}>
                    New password
                  </label>
                  <input
                    type="password"
                    value={newPassword}
                    onChange={e => setNewPassword(e.target.value)}
                    required
                    minLength={8}
                    autoFocus
                    style={{
                      width: '100%', padding: '8px 12px',
                      border: '1px solid var(--color-border)', borderRadius: '6px',
                      fontSize: '14px', background: 'var(--color-surface)',
                      color: 'var(--color-text)', boxSizing: 'border-box'
                    }}
                  />
                </div>
                <div style={{ marginBottom: '24px' }}>
                  <label style={{
                    display: 'block', fontSize: '12px', fontWeight: 600,
                    color: 'var(--color-text-secondary)', marginBottom: '6px',
                    textTransform: 'uppercase', letterSpacing: '0.05em'
                  }}>
                    Confirm password
                  </label>
                  <input
                    type="password"
                    value={confirmPassword}
                    onChange={e => setConfirmPassword(e.target.value)}
                    required
                    style={{
                      width: '100%', padding: '8px 12px',
                      border: '1px solid var(--color-border)', borderRadius: '6px',
                      fontSize: '14px', background: 'var(--color-surface)',
                      color: 'var(--color-text)', boxSizing: 'border-box'
                    }}
                  />
                </div>

                {error && (
                  <div style={{
                    marginBottom: '16px', padding: '10px 12px',
                    background: '#fef2f2', border: '1px solid #fecaca',
                    borderRadius: '6px', fontSize: '13px', color: '#dc2626'
                  }}>
                    {error}
                  </div>
                )}

                <button
                  type="submit"
                  disabled={loading}
                  className="btn btn--primary"
                  style={{ width: '100%', justifyContent: 'center' }}
                >
                  {loading ? 'Saving...' : 'Set new password →'}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
